import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';

// Register necessary components
Chart.register(CategoryScale, LinearScale, BarElement, Title);

const BarChart = ({ labels, data1, chartLabel1, data2, chartLabel2, chartHeight }) => {
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: chartLabel1,
                data: data1,
                backgroundColor: ['#28a745', '#007bff', '#dc3545', '#ffc107','#28a745', '#007bff', '#dc3545', '#ffc107','#28a745', '#007bff', '#dc3545', '#ffc107'],
                barThickness: 20, // Adjust bar thickness
                categoryPercentage: 0.5, // Control bar width
            },
            {
                label: chartLabel2,
                data: data2,
                backgroundColor: ['#007bff', '#ffc107', '#28a745', '#dc3545','#007bff', '#ffc107', '#28a745', '#dc3545','#007bff', '#ffc107', '#28a745', '#dc3545'],
                barThickness: 20, // Adjust bar thickness
                categoryPercentage: 0.5, // Control bar width
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: false, // Ensure bars are not stacked
                barPercentage: 0.5, // Adjust to control width of each bar
                categoryPercentage: 0.8, // Adjust to create space between bars
            },
            y: {
                beginAtZero: true,
            },
        },
    };

    // const options = {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     scales: {
    //         x: {
    //             stacked: true,
    //         },
    //         y: {
    //             stacked: true,
    //         },
    //     },
    // };

    // const options = {
    //     responsive: true,
    //     maintainAspectRatio: false,
    // };

    return (
        // <div className="col-12 col-md-8 mx-auto my-3">
        <div className="card">
            {/* <div className="card-header">Shipment Status Bar Chart</div> */}
            <div className="card-body" style={{ height: chartHeight + 'px' }}>
                <Bar data={chartData} options={options} />
            </div>
        </div>
        // </div>
    );
};

export default BarChart;
